import { cn } from '@/lib/utils';

export interface ThumbUpProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  width?: number;
  height?: number;
  fill?: string;
}

export function ThumbUp({
  size = 16,
  width,
  height,
  fill = '#969AAC',
  className,
  ...props
}: ThumbUpProps) {
  const w = width ?? size;
  const h = height ?? size;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 14.6667 13.3333"
      fill="none"
      className={cn('inline-block flex-shrink-0', className)}
      aria-hidden="true"
      {...props}
    >
      <path
        d="M5.33333 13.3333H11.3333C11.8867 13.3333 12.36 13 12.56 12.52L14.5733 7.82C14.6333 7.66667 14.6667 7.50667 14.6667 7.33333V6C14.6667 5.26667 14.0667 4.66667 13.3333 4.66667H9.12667L9.76 1.62L9.78 1.40667C9.78 1.13333 9.66667 0.88 9.48667 0.7L8.78 0L4.38667 4.39333C4.14667 4.63333 4 4.96667 4 5.33333V12C4 12.7333 4.6 13.3333 5.33333 13.3333ZM5.33333 5.33333L8.22667 2.44L7.33333 6H13.3333V7.33333L11.3333 12H5.33333V5.33333ZM0 5.33333H2.66667V13.3333H0V5.33333Z"
        fill={fill}
      />
    </svg>
  );
}
